import { pipeSizeOptions } from "../../components/BatchSelectionDataTable/helpers/getColumnsValidation";
import { BatchSelectionRow } from "../types";

// When pipe sizes get imported from an excel file or if they are pasted from a different source,
// they are usually the label of option instead of the value. This function remaps the pipe size
// to the correct value if it is not already.
export function remapPipeSize(
  row: BatchSelectionRow,
  prevRow: BatchSelectionRow | undefined,
): BatchSelectionRow {
  if (row.pipeSize === prevRow?.pipeSize) return row;
  const pipeSize = row.pipeSize ?? "";
  return {
    ...row,
    pipeSize:
      pipeSizeOptions.find(
        (option) => option.value === pipeSize || option.label === pipeSize,
      )?.value ?? "",
  };
}
